<template>
    <h1 class="font-sofia-pro text-5xl pb-2 mb-6 w-full">
        <slot></slot>
    </h1>
</template>
